import React, { FC } from "react";
import { css } from "@emotion/core";
//import preval from "preval.macro";
import { Link } from "react-router-dom";
import { Row, Col, Layout, Icon, Button } from "antd";

import { ReactComponent as RumbleWhiteLogo } from "./asset/RideNowLogo.svg";
import googleLogo from "./asset/google-play-logo.png";
import appleLogo from "./asset/apple-store-logo.png";

import { color, minMedia, maxMedia } from "../UiComponents";

const Footer = Layout.Footer;
const  RidenowLogo = require("./asset/RideNowLogo.png");

const flexSharedCss = css`
  display: flex;
  justify-content: center;
  ${minMedia[1]} {
    justify-content: start;
  }
`;

const footerCss = css`
  color: ${color.textWhite};
  background: ${color.logoDark};
  padding: 1.5rem 2rem;
  button,
  a {
    color: ${color.textWhite};
  }
`;

const rowSpecial = css`
  ${flexSharedCss}
  ${maxMedia[1]} {
    flex-wrap: wrap;
    .ant-row:not(:last-child) {
      border-right: 1px solid ${color.borderDark};
    }
  }
`;
const bottomCss = css`
  border-top: 1px solid ${color.borderDark};
  margin-top: 1rem;
  padding-top: 0.5rem;
  ${minMedia[0]} {
    border-top: 0px;
  }
`;

const AppFooter: FC<any> = () => {
  //@todo move to about
  //const buildDate = () => preval`module.exports = new Date().toLocaleString("en-US", {timeZone: "America/Chicago"})`;

  return (
    <Footer css={footerCss}>
      <Row type="flex">
        <Col xs={{ span: 24 }} md={{ span: 6 }} lg={{ span: 8 }}>
          <Row css={flexSharedCss}>
          <img src={RidenowLogo} style={{height:'50px'}}/>
          </Row>
          {/* <Row css={flexSharedCss}>
            <Button
              type="link"
              href="https://itunes.apple.com/us/app/rumbleon-dealer-direct/id1434578832"
              style={{ margin: "1rem 0", paddingLeft: "0px" }}
            >
              <img
                src={appleLogo}
                alt="Apple Store"
                style={{ width: "100px" }}
              />
            </Button>
            <Button
              type="link"
              href="https://play.google.com/store/apps/details?id=com.rumbleon.app"
              style={{ margin: "1rem 0", paddingLeft: "0px" }}
            >
              <img
                src={googleLogo}
                alt="Google Play"
                style={{ width: "100px" }}
              />
            </Button>
          </Row> */}
        </Col>
        <Col
          xs={{ span: 0 }}
          md={{ span: 6, offset: 2 }}
          lg={{ span: 6, offset: 2 }}
        >
          <Row>
            {/* <Link to="https://odoo.rumbleon.com/page/contactus"> */}
            <Button type="link" style={{ paddingLeft: "0px" }}>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.ridenow.com/termsofuse"
              >
                Terms and Conditions
              </a>
            </Button>
          </Row>

          <Row>
            <Button type="link" style={{ paddingLeft: "0px" }}>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.ridenow.com/privacy"
              >
                Privacy Policy
              </a>
            </Button>
          </Row>

          <Row>
            <span style={{ lineHeight: "2rem" }}>Contact</span>
          </Row>
          <Row>
            <Button
              type="link"
              href="tel:480-400-8873"
              style={{ paddingLeft: "0px" }}
            >
              <Icon type="phone" />
              480-400-8873
            </Button>
          </Row>
        </Col>
        <Col
          xs={{ span: 24 }}
          md={{ span: 9, offset: 1 }}
          lg={{ span: 7, offset: 1 }}
          xl={{ span: 6, offset: 2 }}
        >
          <Row css={rowSpecial}>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 0 }}>
                <Button type="link" href="tel:480-400-8873">
                  <Icon type="phone" />
                  480-400-8873
                </Button>
              </Col>
            </Row>

            <Row>
              <Col xs={{ span: 24 }} md={{ span: 0 }}>
                <Button type="link">
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.ridenow.com/terms-conditions"
                  >
                    Terms and Conditions
                  </a>
                </Button>
              </Col>
            </Row>

            <Row>
              <Col xs={{ span: 24 }} md={{ span: 0 }}>
                <Button type="link">
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.ridenow.com/terms-conditions#privacy"
                  >
                    Privacy Policy
                  </a>
                </Button>
              </Col>
            </Row>

            <Row>
              {/* <Link to="/about"> */}
                <Button type="link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.ridenow.com/about">About</Button>
              {/* </Link> */}
            </Row>
            <Row>
              <Button
                type="link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.ridenow.com/careers"
              >
                Career
              </Button>
            </Row>
            <Row>
              <Button
                type="link"
                rel="noopener noreferrer"
                href="https://investors.ridenow.com/?_gl=1%2Axj2wvr%2A_gcl_au%2ANjUxNTQxMzA2LjE3NTUwMTMzOTcuMTY5NjkyMzg3NS4xNzYwNTYwNDQ0LjE3NjA1NjA0NzU.%2A_ga%2AMTc0ODQwNTIxNy4xNjc3MTg2Mzkw%2A_ga_D5BDBBTQVG%2AczE3NjEwNzU0MTEkbzU4JGcxJHQxNzYxMDc2NjIwJGo2MCRsMCRoMjA4MjYxNzQ2NA.."
              >
                Investor Relationships
              </Button>
            </Row>
          </Row>
          <Row css={flexSharedCss}>
            <Button
              type="link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/RideNowPowersports/?_ga=2.124335692.759600833.1675789685-772528720.1666104117"
            >
              <Icon type="facebook" />
            </Button>
            <Button
              type="link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://x.com/RideNowPwrsprts?_ga=2.124335692.759600833.1675789685-772528720.1666104117"
            >
              <Icon type="twitter" />
            </Button>
            <Button
              type="link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/ridenow.powersports/#"
            >
              <Icon type="instagram" />
            </Button>
            <Button
              type="link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCXH1ucCZun1UqGqNdCv7QOw"
            >
              <Icon type="youtube" />
            </Button>
          </Row>
        </Col>
      </Row>
      <Row type="flex" justify="center" css={bottomCss}>
        <p>© 2025 RideNow Powersports. All rights reserved.</p>
      </Row>
    </Footer>
  );
};

export default AppFooter;
